import React from 'react'

import { useFetch } from '../../../../hooks/unrestricted/campaign'
import { useHistory, useParams } from 'react-router-dom'
import Loader from '../../../../components/loader'

import { LAYOUT_PUBLIC_CAMPAIGN_INACTIVE, LAYOUT_PUBLIC_ACCESS_ERROR } from '../../navigation'
import VendorCampaign from '../vendor/create'

const Formulario = (props) => {
  const history = useHistory()
  const { hash } = useParams()
  const { data, isLoading, isError } = useFetch(hash)

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    history.replace(LAYOUT_PUBLIC_ACCESS_ERROR)
    return null
  }

  if (!data.campaign.active) {
    history.replace(LAYOUT_PUBLIC_CAMPAIGN_INACTIVE)
    return null
  }

  if (data.campaign.type === 'vendor') {
    return (
      <VendorCampaign campaignId={data.campaign.id} campaign={data.campaign} {...props} />
    )
  }

  history.replace('/errors/404')
  return null
}
export default Formulario
